angular.module('app.config').config((RestangularProvider) => {
    RestangularProvider.setBaseUrl('/api/1/');
});
